// import { useState } from "react";
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";

// const items = [
// 	{
// 		id: 1,
// 		name: "Dr. G. Yugandher, Quality Manager, Andhra Pradesh State Organic Products Certification Authority (www.apsopca.org)",
// 		content:
// 			"Krishigap provided training on (1) Food Safety and Hygiene based on HACCP principles, (2) Audit Techniques as per ISO 19011, (3) ISO 22000 Lead Auditor (5-day course), and (4) India Good Agricultural Practices. The trainer offered clear explanations and fostered a supportive learning environment. The training significantly enhanced our knowledge, particularly in assessment techniques for India Good Agricultural Practices.",
// 	},
// 	{
// 		id: 2,
// 		name: "Mr. Anand Naik, Grameen Foundation India (www.grameenfoundation.in)",
// 		content:
// 			"Skill development programs for women agripreneurs on India Good Agricultural Practices have empowered them to effectively guide farmers in adopting these practices.",
// 	},
// 	{
// 		id: 3,
// 		name: "CH Balu Naik, Deputy Director of Agriculture, Government of Andhra Pradesh (https://agriculture.ap.gov.in)",
// 		content:
// 			"The instructor-led course on India Good Agricultural Practices, organized for our quality managers, field officers, and technical advisors, was valuable. It provided practical, hands-on guidance that has empowered our team to better support farmer organizations in implementing these standards. ",
// 	},
// 	{
// 		id: 4,
// 		name: "National Institute of Rural Development, Govt of India (www.nirdpr.org.in)",
// 		content:
// 			"The training program on implementing India Good Agricultural Practices (IndG.A.P.) processes and certification protocols, conducted for agricultural officials from the State Governments of Andhra Pradesh, Telangana, Maharashtra, Tamil Nadu, Manipur, Uttarakhand, and Jammu & Kashmir, received overwhelmingly positive feedback, rated as Excellent/Very Good by the participants. The program was organized by the National Institute of Rural Development (NIRD), Hyderabad, from 9th to 13th December 2024",
// 	},
// 	{
// 		id: 5,
// 		name: "T.Sowmya, M.Sc(Ag), Quality Manager, TGOCA, Hyderabad. (https://scadev.seedsgrowerp.com)",
// 		content:
// 			"The 3 days training programme on ISO 17065, NPOP-2024, IS0-19011 and food safety & hygiene conducted by Global Academy for Food Safety and Sustainability Standards held from 12-08-2025 to 14-08-2025 in the Conference hall of Telangana state organic certification Authority (TGOCA), Hyderabad. The Training session was fruitful and appreciable. It helped to our technical staff to improve competence levels on the above standards.",
// 	},
// ];

// const responsive = {
// 	superLargeDesktop: {
// 		breakpoint: { max: 4000, min: 1024 },
// 		items: 3,
// 	},
// 	desktop: {
// 		breakpoint: { max: 1024, min: 768 },
// 		items: 2,
// 	},
// 	tablet: {
// 		breakpoint: { max: 768, min: 464 },
// 		items: 1,
// 	},
// 	mobile: {
// 		breakpoint: { max: 464, min: 0 },
// 		items: 1,
// 	},
// };

// const Carousel1 = () => {
// 	const [expandedItems, setExpandedItems] = useState({});

// 	const toggleReadMore = (id) => {
// 		setExpandedItems((prev) => ({
// 			...prev,
// 			[id]: !prev[id],
// 		}));
// 	};

// 	const truncate = (text, limit = 150) =>
// 		text.length > limit ? text.slice(0, limit) + "..." : text;

// 	return (
// 		<div className="container" style={{ marginBottom: "40px" }}>
// 			<Carousel
// 				responsive={responsive}
// 				arrows={true}
// 				autoPlay
// 				infinite
// 				slidesToSlide={1}>
// 				{items.map((item) => {
// 					const isExpanded = expandedItems[item.id];
// 					const content = isExpanded ? item.content : truncate(item.content);
// 					return (
// 						<div className="carousel-item-wrapper" key={item.id}>
// 							<div className="rating section4-text carousel-item">
// 								{/* Stars */}
// 								<div className="carousel-stars">
// 									<i className="fa fa-star"></i>
// 									<i className="fa fa-star"></i>
// 									<i className="fa fa-star"></i>
// 									<i className="fa fa-star"></i>
// 									<i className="fa fa-star"></i>
// 								</div>

// 								{/* Text content */}
// 								<div className="carousel-content">
// 									<p className="section4-text carousel-paragraph">{content}</p>
// 									{item.content.length > 150 && (
// 										<button
// 											onClick={() => toggleReadMore(item.id)}
// 											className="read-more-btn">
// 											{isExpanded ? "Read Less" : "Read More"}
// 										</button>
// 									)}
// 								</div>

// 								{/* Profile Section */}
// 								<div className="carousel-profile">
// 									<img
// 										src="../images/common-user.svg"
// 										alt="Profile Pic"
// 										className="carousel-avatar"
// 									/>
// 									<div>
// 										<span className="section4-text carousel-name">
// 											{item.name}
// 										</span>
// 										{/* Add this if time is used */}
// 										{/* <span className="section4-text carousel-time">{item.time}</span> */}
// 									</div>
// 								</div>
// 							</div>
// 						</div>
// 					);
// 				})}
// 			</Carousel>
// 		</div>
// 	);
// };

// export default Carousel1;

import { useEffect, useRef, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const items = [
	{
		id: 1,
		name: "Dr. G. Yugandher, Quality Manager, Andhra Pradesh State Organic Products Certification Authority (www.apsopca.org)",
		content:
			"Krishigap provided training on (1) Food Safety and Hygiene based on HACCP principles, (2) Audit Techniques as per ISO 19011, (3) ISO 22000 Lead Auditor (5-day course), and (4) India Good Agricultural Practices. The trainer offered clear explanations and fostered a supportive learning environment. The training significantly enhanced our knowledge, particularly in assessment techniques for India Good Agricultural Practices.",
	},
	{
		id: 2,
		name: "Mr. Anand Naik, Grameen Foundation India (www.grameenfoundation.in)",
		content:
			"Skill development programs for women agripreneurs on India Good Agricultural Practices have empowered them to effectively guide farmers in adopting these practices.",
	},
	{
		id: 3,
		name: "CH Balu Naik, Deputy Director of Agriculture, Government of Andhra Pradesh (https://agriculture.ap.gov.in)",
		content:
			"The instructor-led course on India Good Agricultural Practices, organized for our quality managers, field officers, and technical advisors, was valuable. It provided practical, hands-on guidance that has empowered our team to better support farmer organizations in implementing these standards. ",
	},
	{
		id: 4,
		name: "National Institute of Rural Development, Govt of India (www.nirdpr.org.in)",
		content:
			"The training program on implementing India Good Agricultural Practices (IndG.A.P.) processes and certification protocols, conducted for agricultural officials from the State Governments of Andhra Pradesh, Telangana, Maharashtra, Tamil Nadu, Manipur, Uttarakhand, and Jammu & Kashmir, received overwhelmingly positive feedback, rated as Excellent/Very Good by the participants. The program was organized by the National Institute of Rural Development (NIRD), Hyderabad, from 9th to 13th December 2024",
	},
	{
		id: 5,
		name: "T.Sowmya, M.Sc(Ag), Quality Manager, TGOCA, Hyderabad. (https://scadev.seedsgrowerp.com)",
		content:
			"The 3 days training programme on ISO 17065, NPOP-2024, IS0-19011 and food safety & hygiene conducted by Global Academy for Food Safety and Sustainability Standards held from 12-08-2025 to 14-08-2025 in the Conference hall of Telangana state organic certification Authority (TGOCA), Hyderabad. The Training session was fruitful and appreciable. It helped to our technical staff to improve competence levels on the above standards.",
	},
];

const responsive = {
	superLargeDesktop: {
		breakpoint: { max: 4000, min: 1024 },
		items: 3,
	},
	desktop: {
		breakpoint: { max: 1024, min: 768 },
		items: 2,
	},
	tablet: {
		breakpoint: { max: 768, min: 464 },
		items: 1,
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1,
	},
};

const Carousel1 = () => {
	const cardRefs = useRef([]);
	const [cardHeight, setCardHeight] = useState(null);

	const [expandedItems, setExpandedItems] = useState({});

	useEffect(() => {
		const calculateHeight = () => {
			let maxHeight = 0;

			cardRefs.current.forEach((card) => {
				if (card) {
					card.style.height = "auto";
					maxHeight = Math.max(maxHeight, card.offsetHeight);
				}
			});

			setCardHeight(maxHeight);
		};

		setTimeout(calculateHeight, 100);

		window.addEventListener("resize", calculateHeight);

		return () => {
			window.removeEventListener("resize", calculateHeight);
		};
	}, []);

	const toggleReadMore = (id) => {
		setExpandedItems((prev) => ({
			...prev,
			[id]: !prev[id],
		}));
	};

	const truncate = (text, limit = 150) =>
		text.length > limit ? text.slice(0, limit) + "..." : text;

	return (
		<div className="container" style={{ marginBottom: "40px" }}>
			<Carousel
				responsive={responsive}
				arrows={true}
				autoPlay
				infinite
				slidesToSlide={1}>
				{items.map((item) => {
					const isExpanded = expandedItems[item.id];
					const content = isExpanded ? item.content : truncate(item.content);
					return (
						<div className="carousel-item-wrapper" key={item.id}>
							{/* <div className="rating section4-text carousel-item"> */}
							<div
								className="rating section4-text carousel-item"
								ref={(el) => (cardRefs.current[item.id] = el)}
								style={{
									height: isExpanded ? "auto" : `${cardHeight}px`,
								}}>
								{/* Stars */}
								<div className="carousel-stars">
									<i className="fa fa-star"></i>
									<i className="fa fa-star"></i>
									<i className="fa fa-star"></i>
									<i className="fa fa-star"></i>
									<i className="fa fa-star"></i>
								</div>

								{/* Text content */}
								<div className="carousel-content">
									<p className="section4-text carousel-paragraph">{content}</p>
									{item.content.length > 150 && (
										<button
											onClick={() => toggleReadMore(item.id)}
											className="read-more-btn">
											{isExpanded ? "Read Less" : "Read More"}
										</button>
									)}
								</div>

								{/* Profile Section */}
								<div className="carousel-profile">
									<img
										src="../images/common-user.svg"
										alt="Profile Pic"
										className="carousel-avatar"
									/>
									<div>
										<span className="section4-text carousel-name">
											{item.name}
										</span>
										{/* Add this if time is used */}
										{/* <span className="section4-text carousel-time">{item.time}</span> */}
									</div>
								</div>
							</div>
						</div>
					);
				})}
			</Carousel>
		</div>
	);
};

export default Carousel1;
